import LearnerCard from './LearnerCard';

// Re-export the current implementation as default for backward compatibility
export default LearnerCard;

// Export new components and constants
export { LearnerCard };
export { default as StaffCard } from './StaffCard';
export { CARD_TYPES, CARD_VARIANTS } from './constants';